import { Group } from '@qred/components-library';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '~/store/types/sharedTypes';
import { useOnboardingOfferSelectors } from '~/store/selectors/onboardingOffer.selector';
import {
  setBeneficialOwners,
  updateForm,
} from '~/store/slices/loanOnboardingOffer.slice';
import { isBeneficialOwner } from '~/helpers/onboarding.helper';
import AdditionalOwner from './AdditionalOwner';

const OwnersList = () => {
  const dispatch = useDispatch();
  const { owners, companyHasOtherBeneficialOwners } = useSelector(
    (state: RootState) => state.onboardingOffer.form
  );

  const {
    applicantIsABeneficialOwner,
    applicantIsSoloBeneficialOwner,
  } = useOnboardingOfferSelectors();

  useEffect(() => {
    if (owners.length) {
      const shouldResetOwnersList =
        (applicantIsABeneficialOwner && !companyHasOtherBeneficialOwners) ||
        applicantIsSoloBeneficialOwner;

      if (applicantIsSoloBeneficialOwner) {
        dispatch(
          updateForm({
            companyHasOtherBeneficialOwners: false,
          })
        );
      }

      if (shouldResetOwnersList) {
        dispatch(setBeneficialOwners([]));
      } else {
        dispatch(
          setBeneficialOwners(
            owners.filter((owner) =>
              companyHasOtherBeneficialOwners
                ? isBeneficialOwner(owner.percentage)
                : !isBeneficialOwner(owner.percentage)
            )
          )
        );
      }
    }
  }, [
    companyHasOtherBeneficialOwners,
    applicantIsABeneficialOwner,
    applicantIsSoloBeneficialOwner,
  ]);

  return (
    <Group mt="1em" mb="1em" direction="column" spacing="sm">
      {owners.map((owner) => (
        <AdditionalOwner owner={owner} key={owner.id} />
      ))}
    </Group>
  );
};

export default OwnersList;
